'use client';

import { trackClick } from '../../utilities/track-click';
import { useAnalyticsTenantId } from './analytics-context';

export const TrackedPhoneLink: React.FC<{
  phone: string;
  className?: string;
  target?: string;
  isConversion?: boolean;
  children?: React.ReactNode;
}> = ({ phone, className, target, isConversion, children }) => {
  const tenantId = useAnalyticsTenantId();

  return (
    <a
      className={className}
      href={`tel:${phone}`}
      target={target}
      onClick={() => {
        if (tenantId) trackClick(tenantId, 'phone', `tel:${phone}`, { label: phone, isConversion });
      }}
    >
      {children ?? phone}
    </a>
  );
};
